(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/primary-onboarding/assets/javascripts/fullscreen-mount.js') >= 0) return;  svs.modules.push('/templates/primary-onboarding/assets/javascripts/fullscreen-mount.js');
"use strict";

var _svs$onboarding;

const onboardingDomain = svs.components.lbUtils.onboarding.utils.onboardingDomain;
const createFullscreenEventHandler = svs.components.lbUtils.onboarding.events.eventHandlers.createFullscreenEventHandler;
const FullscreenEventType = svs.components.lbUtils.onboarding.events.constants.FullscreenEventType;
const TemplateSelectors = svs.templates.primaryOnboarding.constants.TemplateSelectors;
const _svs$templates$primar = svs.templates.primaryOnboarding.sessionStorage,
  setItem = _svs$templates$primar.setItem,
  getItem = _svs$templates$primar.getItem;


const onboardingContentEl = document.querySelector(TemplateSelectors.TemplateContent);
const mainContentEl = onboardingContentEl.querySelector(TemplateSelectors.MainContent);
const onboardingFullscreenEl = document.querySelector(TemplateSelectors.TemplateFullscreen);
const _ref = ((_svs$onboarding = svs.onboarding) === null || _svs$onboarding === void 0 || (_svs$onboarding = _svs$onboarding.fullscreen) === null || _svs$onboarding === void 0 ? void 0 : _svs$onboarding.data) || {},
  key = _ref.key,
  count = _ref.count,
  displaycount = _ref.displaycount;
if (mainContentEl && onboardingFullscreenEl && key) {
  const _ref2 = getItem(key) || {
      hasTriggered: false
    },
    hasTriggered = _ref2.hasTriggered;
  if (!hasTriggered) {
    const _createFullscreenEven = createFullscreenEventHandler(),
      addFullscreenEventListener = _createFullscreenEven.addEventListener;
    const _onboardingDomain = onboardingDomain(svs.core.data.module, svs.core.data.baseUrl),
      setCount = _onboardingDomain.setCount;
    const updateCount = () => {
      if (displaycount > 0 && count < displaycount) {
        setCount(key, count + 1);
      }
    };
    const showOnboardingContent = () => {
      mainContentEl.classList.add('onboarding_content--show');
      mainContentEl.classList.remove('onboarding_content--hidden');
    };
    const hideOnboardingContent = () => {
      mainContentEl.classList.add('onboarding_content--hidden');
      mainContentEl.classList.remove('onboarding_content--show');
    };
    const showOnboardingFullscreen = () => {
      onboardingFullscreenEl.classList.add('onboarding_fullscreen--show');
      onboardingFullscreenEl.classList.remove('onboarding_fullscreen--hidden');
    };
    const hideOnboardingFullscreen = () => {
      onboardingFullscreenEl.classList.add('onboarding_fullscreen--hidden');
      onboardingFullscreenEl.classList.remove('onboarding_fullscreen--show');
    };
    const onCloseFullscreen = () => {
      hideOnboardingFullscreen();
      showOnboardingContent();
      onboardingFullscreenEl.parentElement.removeChild(onboardingFullscreenEl);
    };
    mainContentEl.classList.add('onboarding_content');
    addFullscreenEventListener(FullscreenEventType.Show, e => {
      const FullscreenComponent = e.detail.component;
      ReactDOM.render(React.createElement(FullscreenComponent, {
        onCloseFullscreen: onCloseFullscreen
      }), onboardingFullscreenEl);
      updateCount();
      setItem(key, {
        hasTriggered: true
      });
      hideOnboardingContent();
      showOnboardingFullscreen();
    });
    addFullscreenEventListener(FullscreenEventType.Hide, () => {
      onCloseFullscreen();
    });
  }
}

 })(window);